var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", [
        _c(
          "div",
          { staticClass: "col-md-12 no-padding" },
          [
            _c("section-header", {
              attrs: {
                title: _vm.$t("message.general"),
                subtitle: _vm.$t("series.jv") + " " + _vm.jvCode
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-md-2" }, [
                _c("div", { staticClass: "form-group row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("apps.accounting.label.jv_type")))
                      ]),
                      _vm._v(" "),
                      _c("BaseDropdown", {
                        class: [{ "is-invalid": _vm.$v.form.jv_type.$error }],
                        attrs: {
                          options: _vm.journalTypeOptions,
                          disabled: _vm.disabled
                        },
                        model: {
                          value: _vm.$v.form.jv_type.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.form.jv_type, "$model", $$v)
                          },
                          expression: "$v.form.jv_type.$model"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "form-group row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("apps.accounting.label.description"))
                        )
                      ]),
                      _vm._v(" "),
                      _vm.disabled
                        ? _c("BaseInput", {
                            attrs: {
                              value: _vm.replaceCodeToText(
                                _vm.form.description,
                                _vm.$t
                              ),
                              disabled: true
                            }
                          })
                        : _c("BaseInput", {
                            attrs: { disabled: false },
                            model: {
                              value: _vm.form.description,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "description", $$v)
                              },
                              expression: "form.description"
                            }
                          })
                    ],
                    1
                  )
                ])
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("section", [
        _c(
          "div",
          { staticClass: "col-md-12 no-padding" },
          [
            _c("section-header", {
              attrs: {
                title: _vm.$t("apps.accounting.message.journalentrylines")
              }
            }),
            _vm._v(" "),
            _c("JournalEntryLine", {
              attrs: {
                lines: _vm.form.lines,
                isValidated: _vm.$v.$dirty,
                disabled: _vm.disabled
              },
              on: {
                "update:lines": function($event) {
                  return _vm.$set(_vm.form, "lines", $event)
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.showActionButtons
        ? _c("BaseFormAction", {
            attrs: {
              textSubmit: _vm.$t("button.save"),
              isSubmitted: _vm.isSubmitted
            },
            on: { onSubmit: _vm.handleSubmit }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a356b42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a356b42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/JournalEntryForm.vue
// module id = null
// module chunks = 